/**
 * The confirm shown before a published version is copied over the draft.
 *
 * There is one draft per procedure, so bringing a version back into it replaces
 * whatever was there — and the service keeps no history of drafts, so there is
 * nothing to undo it with. Publishing an old version goes the same way, because
 * publish only ever cuts from the draft.
 */

import { Modal } from 'antd';
import React, { FC } from 'react';
import OWButton from '../ow_button/OWButton';

export type AOPVersionIntent = 'edit' | 'publish';

interface AOPEditVersionModalProps {
	open: boolean;
	intent: AOPVersionIntent;
	version: number | null;
	isWorking: boolean;
	onCancel: () => void;
	onConfirm: () => void;
}

export const AOPEditVersionModal: FC<AOPEditVersionModalProps> = ({
	open,
	intent,
	version,
	isWorking,
	onCancel,
	onConfirm,
}) => (
	<Modal
		visible={open}
		title={intent === 'edit' ? 'Edit this version?' : 'Publish this version?'}
		onCancel={onCancel}
		footer={[
			<OWButton key="cancel" onClick={onCancel}>
				Cancel
			</OWButton>,
			<OWButton key="confirm" type="primary" loading={isWorking} onClick={onConfirm}>
				{intent === 'edit' ? 'Edit version' : 'Publish version'}
			</OWButton>,
		]}
	>
		<span className="bodyregular text-character-primary">
			{intent === 'edit'
				? `Editing v${version} will override your current draft. This can't be undone.`
				: `Publishing v${version} will override your current draft and make it the live version. This can't be undone.`}
		</span>
	</Modal>
);

export default AOPEditVersionModal;
